import classNames from 'classnames';
import { AppDataContext } from 'context/appData';
import React, { useContext } from 'react';
import { ReactComponent as WarningIcon } from 'i/icons/warning.svg';
import i18n from 'utils/i18n';
import { useTranslation } from 'react-i18next';

const MaintenanceModePage = ({ key }) => {
	const { t } = useTranslation('notifications');
	const { configuratorData, errorLoadingConfiguratorData } = useContext(AppDataContext);
	const sectionClassNames = classNames('section full_mod section--home_page_mod');
	const BASE_ICON_CLASS = 'icon maintenance_mode_icon';

	return (
		<section id={key} className={sectionClassNames}>
			{(configuratorData || errorLoadingConfiguratorData) && (
				<div className="maintenance_mode">
					<WarningIcon className={BASE_ICON_CLASS} />
					<div className="maintenance_mode_text">
						{errorLoadingConfiguratorData ? (
							<p>{t('errorLoadingConfigurationData')}</p>
						) : (
							<p>
								{
									configuratorData.maintenance_settings?.maintenance_mode?.maintenance_mode_text?.[
										`maintenance_text_${i18n.language}`
									]
								}
							</p>
						)}
					</div>
				</div>
			)}
		</section>
	);
};

export default MaintenanceModePage;
